import { useRef, FC, useEffect, useState } from "react";

import config from "../../../../config/config";
import Content, { ContentNS } from "../../../../content/content";
import { useAppStore } from "../../../../store/store";
import OutlinedButton from "../../../shared/components/buttons/OutlinedButton.styled";
import Body from "../../../shared/styles/typography/Body.styled";
import { ButtonTitle } from "../../../shared/styles/typography/ButtonTitle.styled";
// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import LocalesList from "./styles/LocalesList-APP_CLIENT.styled";
// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
import LocalesListItem from "./styles/LocalesListItem-APP_CLIENT.styled";
// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
import StyledLocalePicker from "./styles/StyledLocalePicker-APP_CLIENT.styled";
import LocalImages from "assets/images/local-images";

const LocalePicker: FC = () => {
  const textUI = (s: string) => Content.shared.t(s, { ns: ContentNS.ui });
  // todo: check if direction is working to RTL
  // const direction = Content.shared.instance.dir()

  const locale = useAppStore((state) => state.locale);
  const changeLocale = useAppStore((state) => state.changeLocale);

  const [open, setOpen] = useState(false);

  const listRef = useRef<HTMLDivElement>(null);

  useEffect(handleOutsideClick);

  return (
    <StyledLocalePicker isVisible={config.supportedLocales.length > 1}>
      <OutlinedButton onClick={onPickerButtonClick}>
        <ButtonTitle>{textUI(`locale.${locale}`)}</ButtonTitle>
        <img
          src={LocalImages.shared.images.icons.chevron.down}
          alt="Dropdown"
        />
      </OutlinedButton>

      <LocalesList isVisible={open} ref={listRef}>
        {config.supportedLocales.map((locale: string) => {
          return (
            <LocalesListItem key={locale} onClick={() => selectLocale(locale)}>
              <Body>{textUI(`locale.${locale}`)}</Body>
            </LocalesListItem>
          );
        })}
      </LocalesList>
    </StyledLocalePicker>
  );

  function onPickerButtonClick(e: React.MouseEvent<HTMLElement>) {
    e.preventDefault();
    e.stopPropagation();
    setOpen(!open);
  }

  function handleOutsideClick() {
    if (!open) {
      return;
    }

    function handleClick(e: Event) {
      if (listRef.current === null) {
        return;
      }

      if (e.target === null) {
        return;
      }

      if (!listRef.current.contains(e.target as HTMLElement)) {
        setOpen(false);
      }
    }

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }

  function selectLocale(locale: string) {
    changeLocale(locale);
    setOpen(false);
  }
};

export default LocalePicker;
